import { Online } from "./Online.js";

var Top = {
  novaSablona: false, //pokud je nova sablona, tak se bude okazovat nove zobrování

  neco: "text1",
  razitko: "1.0.0", //razitko pro brazky atd
  jeIframe: false,
  idStrany: false,
  UrlSite: false,
  zobrazWidget: false,
  localhost: false,
  Online: null,
  jazyk: "cs",
  zobrazitKonfiguratorZbrane: true, //lze vypnout kompletne na strankach
  screenMobil: false,

  Uzivatel: {
    prihlasen: null,
    overeniPrihlaseni: function() {
      let C = window.getShoptetDataLayer("customer");
      return C.mainAccount ? true : false;
    },

    jePrihlasen: function() {
      return Top.Uzivatel.prihlasen;
    },
  },

  isOnline: function() {
    return Top.Online ? Top.Online.isOnline() : false;
  },
  isMobil: function() {
    return this.screenMobil;
  },

  _init: function() {
    Lc.h("Top.init");
    let $stav = Top.Uzivatel.overeniPrihlaseni();
    Top.Uzivatel.prihlasen = $stav;
    let lng = window.getShoptetDataLayer("language") || "cs";
    Top.jazyk = lng;

    Top.localhost = window.ladzoServer || false;
    let def = window.DefLadzo || {};
    Top.Online = new Online(def);

    //this.screenMobil = false;
    if ($("body").hasClass("mobile")) {
      this.screenMobil = true;
    }
  },
};

Top._init();

export { Top };
